import { render, staticRenderFns } from "./result_sjh2.vue?vue&type=template&id=6a5bb4e1&scoped=true"
import script from "./result_sjh2.vue?vue&type=script&lang=js"
export * from "./result_sjh2.vue?vue&type=script&lang=js"
import style0 from "./result_sjh2.vue?vue&type=style&index=0&id=6a5bb4e1&prod&lang=scss&scoped=true"
import style1 from "./result_sjh2.vue?vue&type=style&index=1&id=6a5bb4e1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a5bb4e1",
  null
  
)

export default component.exports